import { render, staticRenderFns } from "./DiiaMessageBox.vue?vue&type=template&id=d0bdd7b2&"
import script from "./DiiaMessageBox.vue?vue&type=script&lang=js&"
export * from "./DiiaMessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports